import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      d: "M14 3.4H0m14 7.2H0"
    }, null, -1)
  ]));
}
const Menu = { render };
export {
  Menu as default,
  render
};
//# sourceMappingURL=Menu.svg.js.map
